// from: /Resources/Private/Layouts/Page/Default.html
const pathsElement = document.getElementById('js-paths');
// const modulePath   = pathsElement.dataset.module;
const cssPath = pathsElement.dataset.css;
// const imagePath    = pathsElement.dataset.images;

// new
// const modulePath = '_assets/fourdegrees/JavaScript/Module';
// const vendorPath = '_assets/fourdegrees/JavaScript/Vendor';
// const imagePath  = '_assets/fourdegrees/JavaScript/Images';


const initTeasersSlider = () => {

    const teasersSlider = document.querySelectorAll('.swiper.teasers__container');
    
    if (teasersSlider[0]) {
        import(
            /* webpackChunkName: "webpack-swiper-teasersslider" */
            './Module/swiper-teasersslider.js'
        ).then(module => {
            module.initSwiper(teasersSlider);
        }).catch(err => {
            console.error('Error in teasersSlider module: ', err);
        });
    }
}


const initCardSlider = () => {

    const cardSlider = document.querySelectorAll('.swiper.cardslider__container');
    
    if (cardSlider[0]) {
        import(
            /* webpackChunkName: "webpack-swiper-teasersslider" */
            './Module/swiper-cardslider.js'
        ).then(module => {
            module.initSwiper(cardSlider);
        }).catch(err => {
            console.error('Error in cardSlider module: ', err);
        });
    }
}


const initIconteasersSlider = () => {

    const teasersSlider = document.querySelectorAll('.swiper.iconteasers__container');
    
    if (teasersSlider[0]) {
        import(
            /* webpackChunkName: "webpack-swiper-iconteasersslider" */
            './Module/swiper-iconteasersslider.js'
        ).then(module => {
            module.initSwiper(teasersSlider);
        }).catch(err => {
            console.error('Error in teasersSlider module: ', err);
        });
    }
}


const initImageSlider = () => {

    const imageSlider = document.querySelectorAll('.swiper.imageSlider__container ');
    
    if (imageSlider[0]) {
        import(
            /* webpackChunkName: "webpack-swiper-imageslider" */
            './Module/swiper-imageslider.js'
        ).then(module => {
            module.initSwiper(imageSlider);
        }).catch(err => {
            console.error('Error in imageSlider module: ', err);
        });
    }
}


const initQuotesSlider = () => {

    const quotesSlider = document.querySelectorAll('.swiper.quotesSlider__container');
    
    if (quotesSlider[0]) {
        import(
            /* webpackChunkName: "webpack-swiper-quotesslider" */
            './Module/swiper-quotesslider.js'
        ).then(module => {
            module.initSwiper(quotesSlider);
        }).catch(err => {
            console.error('Error in swiper-quotesslider module: ', err);
        });
    }
}


const initTextMediaSlider = () => {

    const textMediaSlider = document.querySelectorAll('.swiper.gallerySlider');
    
    if (textMediaSlider[0]) {
        import(
            /* webpackChunkName: "webpack-swiper-textmediaslider" */
            './Module/swiper-textmediaslider.js'
        ).then(module => {
            module.initSwiper(textMediaSlider);
        }).catch(err => {
            console.error('Error in swiper-textmediaslider module: ', err);
        });
    }
}


const initMenuTeaserSlider = () => {

    const menuTeaserSlider = document.querySelectorAll('.swiper.navDrop__teasers');
    
    if (menuTeaserSlider[0]) {
        import(
            /* webpackChunkName: "webpack-swiper-menuteaserslider" */
            './Module/swiper-menuteaserslider.js'
        ).then(module => {
            module.initSwiper(menuTeaserSlider);
        }).catch(err => {
            console.error('Error in swiper-menuTeaser module: ', err);
        });
    }
}


const initAccordions = () => {

    const accordionSelector = '.js-accordion';
  
    if (document.querySelector(accordionSelector)) {

        import(
            /* webpackChunkName: "webpack-accordions" */
            './Module/accordions.js'
        ).then(module => {
            module.initAccordion(accordionSelector);
        }).catch(err => {
            console.error('Error in accordion module: ', err);
        });
    }
};


const initFigures = () => {

    const figures = document.querySelectorAll('.js-countUp');
    
    if (figures[0]) {

        import(
            /* webpackChunkName: "webpack-figures" */
            './Module/figures.js'
        ).then(module => {
            module.initFigures(figures);
        }).catch(err => {
            console.error('Error in figures module: ', err);
        });
    }
}


const initVideos = () => {

    const videoWrappers = document.querySelectorAll('.video');
    
    if (videoWrappers[0]) {

        videoWrappers.forEach((videoWrap) => {

            const video       = videoWrap.querySelector('video');
            const button      = videoWrap.querySelector('.video__posterButton');
            const posterImage = videoWrap.querySelector('.video__poster');
            
            if(!button || !posterImage) return;

            button.addEventListener('click', () => {
                video.play();
                if (posterImage) posterImage.style.opacity = '0';
            })  
        })
    }
}


const initMenu = () => {

    import(
        /* webpackChunkName: "webpack-menu" */
        './Module/menu.js'
    ).then(module => {
        module.initMenu();
    }).catch(err => {
        console.error('Error in menu module: ', err);
    });
};


const initFocus = () => {

    document.addEventListener('keydown', function(e) {
        if (e.key === 'Tab') {
            document.body.classList.remove('js-hideOutline');
        }
    });

    document.addEventListener('mousedown', function() {
        document.body.classList.add('js-hideOutline');
    });
};

const initTimeline = () => {
    const timelineElement = document.querySelector('.js-items');
    if (timelineElement) {

        import(
            /* webpackChunkName: "webpack-timeline" */
            './Module/timeline.js'
        ).then(module => {
            module.Timeline.init({
                itemsSelector: '.js-items',
                trackSelector: '.js-track',
                thumbSelector: '.js-thumb',
                prevButtonSelector: '.js-timelinePrev',
                nextButtonSelector: '.js-timelineNext',
                contentSelector: '.js-content',
            });
        }).catch(err => {
            console.error('Error in Timeline module: ', err);
        });
    }
};


const initNewsMasonry = () => {

    const newsList = document.querySelector('.newsList__inner');
    
    if (newsList) {
        new Masonry( newsList, {
            itemSelector: '.newsListArticle',
            columnWidth: '.newsListArticle',
            gutter: '.newsList__gutterSizer',
            percentPosition: false
        });
    }
}

const initNewsCategories = () => {

    const available = document.querySelector('.newsCategories--news .newsCategories__itemLink');
    
    if (available) {
        import(
            /* webpackChunkName: "webpack-ajaxReplace" */
            './Module/ajaxReplace.js'
        ).then(module => {
            module.default({
                button:    '.newsCategories__itemLink',
                container: '.newsList',
                callback:   initNewsMasonry
            });
        }).catch(err => {
            console.error('Error loading AjaxReplace module: ', err);
        });
    }
};

const initEventsCategories = () => {
    const available = document.querySelector('.newsCategories--events .newsCategories__itemLink');

    if (available) {
        import(
            /* webpackChunkName: "webpack-ajaxReplace" */
            './Module/ajaxReplace.js'
        ).then(module => {
            console.log('events')
            module.default({
                button:    '.newsCategories__itemLink',
                container: '.eventsList'
            });
        }).catch(err => {
            console.error('Error loading AjaxReplace module: ', err);
        });
    }
};


const initNewsPaging = () => {
    const available = document.querySelector('.newsList');

    if (available) {
        import(
            /* webpackChunkName: "webpack-ajaxAppend" */
            './Module/ajaxAppend.js'
        ).then(module => {

            const newsPagingToggle = new module.default({
                button:     '.newsList__loadMore',
                container:  '.newsList',
                callback:   initNewsMasonry
            });

        }).catch(err => {
            console.error('Error loading AjaxAppend module: ', err);
        });
    }
};


const initNewsBreadcrumb = async () => {

    const breadcrumb = document.querySelector('.breadcrumb');
    const contentTop = document.querySelector('.js-beforeBreadcrumb');

    if(!breadcrumb || !contentTop) return;

    contentTop.before(breadcrumb);
};


const initNewsTeaser = () => {

    const newsTeaser = document.querySelectorAll('.swiper.newsTeaser__container');
    
    if (newsTeaser[0]) {
        import(
            /* webpackChunkName: "webpack-swiper-newsteaserslider" */
            './Module/swiper-newsteaserslider.js'
        ).then(module => {
            module.initSwiper(newsTeaser);
        }).catch(err => {
            console.error('Error in newsTeaser module: ', err);
        });
    }
}


const initBreadcrumbColor = async () => {

    const breadcrumb  = document.querySelector('.breadcrumb');
    const nextElement = document.querySelector('.content--main .frame');

    if(!breadcrumb || !nextElement) return;

    const backgrounds = ['frame-background-sisal', 'frame-background-red', ] 

    backgrounds.forEach(element => {
        if (nextElement.classList.contains(element)) {
            breadcrumb.classList.add(element);
        } 
    });
};


const initDatepicker = () => {

    const datePicker = document.getElementById('datePicker');
    
    if (datePicker) {
        import(
            /* webpackChunkName: "webpack-datepicker" */
            './Module/datepicker.js'
        ).then(module => {
            module.initDatepicker(datePicker, cssPath);
        }).catch(err => {
            console.error('Error in datepicker module: ', err);
        });
    }
}


const initSearch = () => {
    const searchButtons = document.querySelectorAll('.js-searchButton');

    if (searchButtons.length > 0) {
        import(
            /* webpackChunkName: "webpack-search" */
            './Module/search.js'
        ).then(module => {
            module.default(searchButtons);
        }).catch(err => {
            console.error('Error loading search module: ', err);
        });
    }
};


const initSearchSuggest = () => {
    import(
        /* webpackChunkName: "webpack-search-suggest" */
        './Module/search-suggest.js'
    ).then(module => {
        module.initSuggest();
    }).catch(err => {
        console.error('Error loading search-suggest module: ', err);
    });    
}


document.addEventListener("DOMContentLoaded", () => {
    initTeasersSlider();
    initCardSlider();
    initIconteasersSlider();
    initImageSlider();
    initQuotesSlider();
    initTextMediaSlider();
    initMenuTeaserSlider();
    initAccordions();
    initFigures();
    initVideos();
    initMenu();  
    initFocus();
    initTimeline();
    initNewsMasonry();
    initNewsPaging();
    initNewsCategories();
    initEventsCategories();
    initNewsBreadcrumb();
    initNewsTeaser();
    initBreadcrumbColor();
    initDatepicker();
    initSearch();
    initSearchSuggest();
});